export const RESPONSE_TIMEOUT_MS = 1000 * 15;
